import { createContext, useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import dateformat from 'dateformat'
import axios from "axios";
import  secureLocalStorage  from  "react-secure-storage";
const HistorialCitasPacienteContext = createContext()

const client = axios.create({
  baseURL: "https://appsexpedientemedico.azurewebsites.net/api"
});
// https://appsexpedientemedico.azurewebsites.net/api
const HistorialCitasPacienteProvider = ({ children }) => {


  const { validarToken } = useAuth()

  const [loadTime, setLoadTime] = useState(false)
  const [datos, setDatos] = useState({
    fechaInicio: dateformat(new Date(), "yyyy-mm-dd"),
    fechaFin: dateformat(new Date(), "yyyy-mm-dd")
  })
  const { fechaInicio, fechaFin } = datos

  const [error, setError] = useState({
    band: false,
    texto: ''
  })

  const [citasUsuario, setCitasUsuario] = useState([])

  const handleChangeDatos = (event) => {
    setDatos({
      ...datos,
      [event.target.name]: event.target.value
    });
  };

  const consultarCitas = async (fechainicio, fechafin) => {
    try {
      setLoadTime(true)
      validarToken()
      let token = secureLocalStorage.getItem('tokenid');
      const guidPaciente = localStorage.getItem('idguidpaciente')
  
      const data = {
        "fi": fechainicio,
        "ff": fechafin,
        "clientGuid": guidPaciente
      }
      const response = await client.post(`/citas/citaHistorialbyClientGuid`, data, {
        headers: {
          Authorization: `Bearer ${secureLocalStorage.getItem('tokenid')}`,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE',
          'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
          'Content-Type': 'application/json',
        }
      })
      if (typeof response.data.response === "string") {
        
        setCitasUsuario([]);
        setError({ band: true, texto: response.data.response })
      }else{
        setCitasUsuario(response.data.response);
        
      }
      //
      setLoadTime(false)

    } catch (e) {
      setLoadTime(false)
    }
  }
  
  
  

  useEffect(() => {
    consultarCitas(fechaInicio, fechaFin)
  }, [])

  return (
    <HistorialCitasPacienteContext.Provider
      value={{
        citasUsuario,
        handleChangeDatos,
        datos,
        setError,
        error,
        consultarCitas,
        loadTime,
      }}
    >
      {children}
    </HistorialCitasPacienteContext.Provider>
  )
}

export {
  HistorialCitasPacienteProvider
}

export default HistorialCitasPacienteContext